import { TextField } from 'components/ui';
import { Text, TEXT_VARIANTS } from 'components/ui/Typography';
import React, { useRef } from 'react';

const AddProfileStepOne = ({ jobTitle, setJobTitle, setCurrentStep }) => {
  const jobTitleRef = useRef();
  return (
    <div className="d-f w-100p mt-72 ml-8 mr-6 fd-c h-150">
      <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD_DARK}>
        {t('skills.add_job_title')}
        <span className="llui-text-instrux-error ml-4">*</span>
      </Text>
      <TextField
        whiteBackground
        ref={jobTitleRef}
        placeholder={t('skills.job_title_input')}
        value={jobTitle}
        onChange={e => {
          setJobTitle(e.target.value);
        }}
        aria-label={t('skills.job_title_input')}
        className="mt-8"
      />
    </div>
  );
};

export default AddProfileStepOne;
